var render = function render(){var _vm=this,_c=_vm._self._c;return _c('input',{attrs:{"type":_vm.type,"maxlength":_vm.maxlength,"fieldType":_vm.fieldType,"compname":_vm.compname,"phoneFormat":_vm.phoneFormat,"isCountryCodeEnabled":_vm.isCountryCodeEnabled,"id":_vm.id,"name":_vm.name,"placeholder":_vm.placeholder},domProps:{"value":_vm.value},on:{"input":_vm.updateValue}})
}
var staticRenderFns = []

export { render, staticRenderFns }